'use client';

import React, { createContext, useContext, useMemo, useState } from 'react';

type PageConfig = {
  title?: string;
  titleIcon?: React.FC<{ className?: string }>;
  backURL?: string;
  headerActions?: React.ReactNode;
};

type PageConfigContextValue = {
  config: PageConfig;
  setPageConfig: (next: PageConfig) => void;
};

const PageConfigContext = createContext<PageConfigContextValue | null>(null);

export function PageConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setPageConfig] = useState<PageConfig>({});

  const value = useMemo(() => ({ config, setPageConfig }), [config]);
  return <PageConfigContext.Provider value={value}>{children}</PageConfigContext.Provider>;
}

export function usePageConfig() {
  const ctx = useContext(PageConfigContext);
  if (!ctx) throw new Error('usePageConfig must be used within PageConfigProvider');
  return ctx;
}
